import store from "../../../../../store";
import workspace from "../core/workspace";
import {setSqftCroppedSlabImages} from "../../../../../actions/sqftSlabFunctions";
import sqftEventManager from "./sqftEventManager";
import MovableImage from "../core/shapes/movableImage";
import {APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE, SHAPE_TYPE} from "../../../constants";

const sqftImageManager = {
  getAppliances: function() {
    const shapes = workspace.getShapes();
    return shapes.filter(shp => shp.type === SHAPE_TYPE.appliances);
  },
  getSlabImages: function() {
    const state = store.getState();
    return state.sqftSlabState.croppedSlabImages;
  },
  getAppliancesThatShouldRenderMeasurementsInsideTheShape: function() {
    const shapes = workspace.getShapes();
    return shapes.filter(shp => shp.type === SHAPE_TYPE.appliances
     && APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE.includes(shp.subType));
  },
  hideSlabImages: function() {
    let movableImages = store.getState().sqftSlabState.croppedSlabImages;
    for (let i = movableImages.length - 1; i >= 0; i--) {
      movableImages[i].deregisterEvents();
    }
  },
  restoreSlabImages: function() {
    let movableImages = store.getState().sqftSlabState.croppedSlabImages;
    for (let i = movableImages.length - 1; i >= 0; i--) {
      movableImages[i].reInitEvents();
    }
  },
  getExportedSlabImages: function () {
    let slabState = store.getState().sqftSlabState;
    let croppedImages = slabState.croppedSlabImages;
    let exportData = [];
    for(let croppedImage of croppedImages) {
      exportData.push(croppedImage.export());
    }

    return exportData;
  },

  removeAllSlabImages: function () {
    const state = store.getState();
    let slabImages = state.sqftSlabState.croppedSlabImages;
    if (slabImages.length > 0) {
      store.dispatch(setSqftCroppedSlabImages([]));
    }
  },

  /**
   * @param {[]} data
   */
  importSlabImages: function (data) {
    if (data.length === 0) {
      sqftImageManager.removeAllSlabImages();
      return
    }
    let workspaceImages = [];
    for(let movableImageData of data) {
      let image = new Image();
      image.src = movableImageData.image.src;

      let workspaceImage = workspace.addImage(
        image,
        movableImageData.size.width,
        Object.hasOwn(movableImageData.size, 'depth') ? movableImageData.size.depth : movableImageData.size.height, // compatibility for old quotes
        null,
        null,
        "slabImage",
        null,
        function () {},
        movableImageData.pos,
        null,
        movableImageData.id,
        sqftEventManager.priorities.SLAB_IMAGE,
        movableImageData.featureId,
        true
      );

      workspaceImage.importData({isDisabledInPopup: movableImageData.isDisabledInPopup});
      workspaceImages.push(workspaceImage)
    }

    store.dispatch(setSqftCroppedSlabImages(workspaceImages));
  },
  hideImages: function() {
    const shapes = workspace.getShapes();
    for (let shape of shapes) {
      if (shape instanceof MovableImage && shape.type !== 'slabImage') {
        shape.deregisterEvents();
      }
    }
  },
  restoreImages: function() {
    const shapes = workspace.getShapes();
    for (let shape of shapes) {
      if (shape instanceof MovableImage && shape.type !== 'slabImage') {
        shape.reInitEvents();
      }
    }
  },
  hideTextBoxes: function() {
    const textBoxes = workspace.textBoxManager.getTextBoxes();
    for (let textBox of textBoxes) {
      textBox.deregisterEvents();
    }
  },
  restoreTextBoxes: function() {
    const textBoxes = workspace.textBoxManager.getTextBoxes();
    for (let textBox of textBoxes) {
      textBox.reInitEvents();
    }
  },
  getMinMaxShapePoints: function(movableImage) {
    let size = movableImage.getSize();
    return {
      minX : 0,
      maxX : size.width,
      minY : 0,
      maxY : size.depth
    }
  },
};

export default sqftImageManager
